import { useEffect, useRef, useState } from 'react';
import { Modal, Box, Text, Button, Alert } from '@mantine/core';
import { IconCamera, IconAlertTriangle } from '@tabler/icons-react';
import { BrowserPDF417Reader } from '@zxing/browser';
import { parseDniPdf417 } from '../utils/parseDniPdf417';

const ModalDniScan = ({ isOpen, onClose, onScanned }) => {
  const videoRef = useRef(null);
  const controlsRef = useRef(null);
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState(null);

  const stopCamera = () => {
    controlsRef.current?.stop();
    controlsRef.current = null;
    setScanning(false);
  };

  useEffect(() => {
    if (!isOpen) stopCamera();
    return stopCamera;
  }, [isOpen]);

  const handleActivarCamara = async () => {
    setError(null);
    setScanning(true);
    try {
      const reader = new BrowserPDF417Reader();
      controlsRef.current = await reader.decodeFromConstraints(
        { video: { facingMode: 'environment' } },
        videoRef.current,
        (result) => {
          if (!result) return;
          const parsed = parseDniPdf417(result.getText());
          if (parsed) {
            stopCamera();
            onScanned(parsed);
          }
        }
      );
    } catch (err) {
      setScanning(false);
      if (err?.name === 'NotAllowedError') {
        setError('No pudimos acceder a la cámara. Cargá los datos manualmente.');
      } else {
        setError('No pudimos iniciar el escaneo. Cargá los datos manualmente.');
      }
    }
  };

  const handleClose = () => {
    stopCamera();
    onClose();
  };

  return (
    <Modal
      opened={isOpen}
      onClose={handleClose}
      title="Escanear DNI argentino"
      centered
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
    >
      <Box p={'5px 10px'}>
        <Alert color="blue" mb="md" icon={<IconAlertTriangle size={18} />}>
          Esta función solo funciona con el DNI argentino tarjeta (el que tiene el
          código de barras en el frente). El video se procesa en tu navegador: no se
          sube ni se guarda en ningún servidor.
        </Alert>

        {error && (
          <Text size="sm" c="red" mb="sm">
            {error}
          </Text>
        )}

        <Box
          style={{
            background: '#000',
            borderRadius: 8,
            overflow: 'hidden',
            display: scanning ? 'block' : 'none',
          }}
        >
          <video ref={videoRef} style={{ width: '100%', display: 'block' }} muted playsInline />
        </Box>

        {scanning && (
          <Text size="xs" c="dimmed" ta="center" mt="xs">
            Apuntá la cámara al código de barras del frente del DNI
          </Text>
        )}

        {!scanning && (
          <Button
            leftSection={<IconCamera size={18} />}
            color="rgb(242, 10, 95)"
            fullWidth
            mt="md"
            onClick={handleActivarCamara}
          >
            Activar cámara
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default ModalDniScan;
